module.exports = __webpack_public_path__ + "img/gray-3.f9994383.svg";